<script setup lang="ts">
  import PosUiBadge from '@/components/pos-v2/ui/PosUiBadge.vue';
  import type { TReservationSource } from '@/interfaces/IReservation';
  defineProps<{ source: TReservationSource; compact?: boolean }>();
  const icons: Record<TReservationSource, string> = {
    online: 'web',
    phone: 'phone',
    staff: 'account-tie',
    walk_in: 'walk',
    waitlist: 'clipboard-list-outline',
  };
</script>

<template>
  <PosUiBadge
    class="source-badge"
    :class="{ compact }"
    color="neutral"
    size="xs"
    :icon="icons[source]"
    :title="$t(`reservations.source.${source}`)"
  >
    <span class="source-label" :class="{ compact }">{{
      $t(`reservations.source.${source}`)
    }}</span>
  </PosUiBadge>
</template>

<style scoped lang="scss">
  .source-label.compact {
    @apply tw-hidden sm:tw-inline;
  }
  // Icon only on phones: no space after the icon.
  .source-badge.compact :deep(.pos-ui-badge-icon) {
    @apply tw-mr-0 sm:tw-mr-1;
  }
</style>
